module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component component-backoffice-deposit-configuration"
  }, [(!_vm.value || _vm.value.length === 0) ? _c('div', {
    staticClass: "def"
  }, _vm._l((_vm.item.default), function(elem, index) {
    return _c('div', {
      staticClass: "row"
    }, _vm._l((elem), function(val, inx) {
      return _c('div', {
        staticClass: "column"
      }, [_c('input', {
        attrs: {
          "type": "text",
          "placeholder": inx,
          "disabled": "disabled"
        },
        domProps: {
          "value": _vm.item.default[index][inx]
        }
      })])
    }), 0)
  }), 0) : _vm._l((_vm.value), function(elem, index) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "column shrink delete"
    }, [_c('DeleteConf', {
      on: {
        "click": function($event) {
          return _vm.value.splice(index, 1)
        }
      }
    })], 1), _vm._l((elem), function(val, inx) {
      return _c('div', {
        staticClass: "column"
      }, [(inx === 'strategy') ? _c('div', {
        staticClass: "strategy"
      }, [_c('label', [_vm._v(_vm._s(inx)), _c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.value[index].strategy),
          expression: "value[index].strategy"
        }],
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(_vm.value[index], "strategy", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, _vm._l((_vm.strategies), function(strategy) {
        return _c('option', [_vm._v(_vm._s(strategy))])
      }), 0)])]) : (inx === 'booking_mode') ? _c('div', {
        staticClass: "booking-mode"
      }, [_c('label', [_vm._v(_vm._s(inx)), _c('BookingModeSelect', {
        attrs: {
          "isFilter": true
        },
        model: {
          value: (_vm.value[index].booking_mode),
          callback: function($$v) {
            _vm.$set(_vm.value[index], "booking_mode", $$v)
          },
          expression: "value[index].booking_mode"
        }
      })], 1)]) : (inx === 'plan') ? _c('div', {
        staticClass: "booking-mode"
      }, [_c('label', [_vm._v(_vm._s(inx)), _c('SelectizePlan', {
        attrs: {
          "allowEmptyOption": true,
          "selectedValue": parseInt(_vm.value[index].plan)
        },
        on: {
          "optionSelected": function($event) {
            return _vm.setPlan($event, index)
          },
          "optionRemoved": function($event) {
            return _vm.unsetPlan(index)
          }
        }
      })], 1)]) : (inx === 'vehicle_category') ? _c('div', {
        staticClass: "vehicle-category"
      }, [_c('label', [_vm._v(_vm._s(inx)), _c('SelectizeCategory', {
        attrs: {
          "allowEmptyOption": true,
          "selectedValue": parseInt(_vm.value[index].vehicle_category)
        },
        on: {
          "optionSelected": function($event) {
            return _vm.setCategory($event, index)
          },
          "optionRemoved": function($event) {
            return _vm.unsetCategory(index)
          }
        }
      })], 1)]) : _c('div', {
        staticClass: "other-val"
      }, [_c('label', [_vm._v(_vm._s(inx)), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.value[index][inx]),
          expression: "value[index][inx]"
        }],
        attrs: {
          "type": "text",
          "placeholder": inx
        },
        domProps: {
          "value": (_vm.value[index][inx])
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.value[index], inx, $event.target.value)
          }
        }
      })])])])
    })], 2)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-306bb1b0!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/configuration/DepositConfiguration.vue
// module id = 2380
// module chunks = 1